<div class="content-hack">
	<div class="container-fluid tpl3pl-dashboard-shell">
		<div class="row">
				<div class="col-12" *ngIf="!loading && !status?.configured">
					<div class="card card-stats">
						<div class="card-header card-header-warning card-header-icon">
							<div class="card-icon">
								<i class="material-icons">settings</i>
							</div>
							<p class="card-category">3PL integration is not configured</p>
							<h3 class="card-title">—</h3>
							<small>
								<p class="card-category text-info text-justify mt-3 text-right">Open 3PL settings to choose your provider and warehouse.</p>
							</small>
						</div>
						<div class="card-footer">
							<div class="stats">
								<a routerLink="/tpl3pl/config" class="btn btn-primary btn-sm">3PL settings</a>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 text-center py-5" *ngIf="loading">
					<svg class="spinner" width="48px" height="48px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
					<p class="mt-3 mb-0 text-muted">Loading dashboard data…</p>
				</div>

				<ng-container *ngIf="!loading && status?.configured">
					<ng-container *ngIf="status?.order_invoice_metrics as oim">
						<div class="col-lg-4 col-md-4 col-sm-6">
							<div class="card card-stats">
								<div class="card-header card-header-rose card-header-icon">
									<div class="card-icon">
										<i class="material-icons">shopping_cart</i>
									</div>
									<p class="card-category">Volume (last {{ oim.totals_days }}d)</p>
									<h3 class="card-title">{{ oim.totals?.orders ?? 0 }}</h3>
									<small>
										<p class="card-category text-info text-justify mt-3 text-right">
											Invoices posted: {{ oim.totals?.invoices ?? 0 }}<br>
											Distinct orders invoiced: {{ oim.totals?.invoiced_orders_distinct ?? 0 }}
										</p>
									</small>
								</div>
							</div>
						</div>
						<div class="col-lg-4 col-md-4 col-sm-6">
							<div class="card card-stats">
								<div class="card-header card-header-warning card-header-icon">
									<div class="card-icon">
										<i class="material-icons">linear_scale</i>
									</div>
									<p class="card-category">Pipeline (now)</p>
									<h3 class="card-title">{{ (oim.pipeline?.queued_not_exported_orders ?? 0) + (oim.pipeline?.exported_awaiting_shipment ?? 0) + (oim.pipeline?.shipped_awaiting_invoice_orders ?? 0) }}</h3>
									<small>
										<p class="card-category text-info text-justify mt-3 text-right">
											Queued (not exported): {{ oim.pipeline?.queued_not_exported_orders ?? 0 }}<br>
											Exported, no shipment: {{ oim.pipeline?.exported_awaiting_shipment ?? 0 }}<br>
											Shipped, no invoice: {{ oim.pipeline?.shipped_awaiting_invoice_orders ?? 0 }}
										</p>
									</small>
								</div>
							</div>
						</div>
						<div class="col-lg-4 col-md-4 col-sm-6">
							<div class="card card-stats">
								<div class="card-header card-header-info card-header-icon">
									<div class="card-icon">
										<i class="material-icons">schedule</i>
									</div>
									<p class="card-category">Recovery (median · last {{ oim.recovery_window_days }}d)</p>
									<h3 class="card-title">{{ (oim.recovery_minutes?.sample_orders ?? 0) > 0 ? recoveryFromMinutes(oim.recovery_minutes?.order_to_first_invoice_median) : '—' }}</h3>
									<small>
										<p class="card-category text-info text-justify mt-3 text-right">
											From first order → first invoice<br>
											From first shipment: {{ recoveryFromMinutes(oim.recovery_minutes?.first_ship_to_first_invoice_median) }}<br>
											From first 3PL export: {{ recoveryFromMinutes(oim.recovery_minutes?.first_export_to_first_invoice_median) }}
											<span *ngIf="(oim.recovery_minutes?.sample_orders ?? 0) > 0"><br><span class="text-muted">n={{ oim.recovery_minutes?.sample_orders }}</span></span>
											<span *ngIf="(oim.recovery_minutes?.sample_orders ?? 0) === 0"><br><span class="text-muted">No exported + invoiced orders in this window</span></span>
										</p>
									</small>
								</div>
							</div>
						</div>
						<div class="col-lg-4 col-md-4 col-sm-6">
							<div class="card card-stats">
								<div class="card-header card-header-warning card-header-icon">
									<div class="card-icon">
										<i class="material-icons">hourglass_empty</i>
									</div>
									<p class="card-category">Unbilled exported (last {{ oim.recovery_window_days }}d)</p>
									<h3 class="card-title">{{ oim.unbilled_exported?.orders ?? 0 }}</h3>
									<small>
										<p class="card-category text-info text-justify mt-3 text-right">
											Exported orders with no real invoice yet<br>
											Median age: {{ (oim.unbilled_exported?.orders ?? 0) > 0 ? recoveryFromMinutes(oim.unbilled_exported?.median_age_minutes) : '—' }}<br>
											Avg age: {{ (oim.unbilled_exported?.orders ?? 0) > 0 ? recoveryFromMinutes(oim.unbilled_exported?.avg_age_minutes) : '—' }}
										</p>
									</small>
								</div>
							</div>
						</div>
						<ng-container *ngIf="!oiDetailMetric">
							<div class="col-lg-4 col-md-4 col-sm-6">
								<div class="card card-stats tpl3pl-throughput-summary-card">
									<div class="card-header card-header-rose card-header-icon">
										<div class="card-icon">
											<i class="material-icons">assignment</i>
										</div>
										<p class="card-category">Orders</p>
										<h3 class="card-title tpl3pl-throughput-summary-card__hero">{{ rollAvgOrders | number:'1.0-1' }}</h3>
										<small>
											<p class="card-category text-info text-justify mt-2 text-right mb-0">
												Rolling avg / day · selected range<br>
												Total {{ rollTotalOrders | number:'1.0-0' }}
											</p>
										</small>
									</div>
									<div class="card-footer">
										<div class="stats">
											<a href="javascript:void(0)" class="pointer" (click)="toggleOiDetail('orders'); $event.preventDefault()"><i class="material-icons">visibility</i> View</a>
										</div>
									</div>
								</div>
							</div>
							<div class="col-lg-4 col-md-4 col-sm-6">
								<div class="card card-stats tpl3pl-throughput-summary-card">
									<div class="card-header card-header-warning card-header-icon">
										<div class="card-icon">
											<i class="material-icons">publish</i>
										</div>
										<p class="card-category">Exported</p>
										<h3 class="card-title tpl3pl-throughput-summary-card__hero">{{ rollAvgExported | number:'1.0-1' }}</h3>
										<small>
											<p class="card-category text-info text-justify mt-2 text-right mb-0">
												Rolling avg / day · selected range<br>
												Total {{ rollTotalExported | number:'1.0-0' }}
											</p>
										</small>
									</div>
									<div class="card-footer">
										<div class="stats">
											<a href="javascript:void(0)" class="pointer" (click)="toggleOiDetail('exported'); $event.preventDefault()"><i class="material-icons">visibility</i> View</a>
										</div>
									</div>
								</div>
							</div>
							<div class="col-lg-4 col-md-4 col-sm-6">
								<div class="card card-stats tpl3pl-throughput-summary-card">
									<div class="card-header card-header-info card-header-icon">
										<div class="card-icon">
											<i class="material-icons">receipt</i>
										</div>
										<p class="card-category">Invoiced</p>
										<h3 class="card-title tpl3pl-throughput-summary-card__hero">{{ rollAvgInvoiced | number:'1.0-1' }}</h3>
										<small>
											<p class="card-category text-info text-justify mt-2 text-right mb-0">
												Rolling avg / day · selected range<br>
												Total {{ rollTotalInvoiced | number:'1.0-0' }}
											</p>
										</small>
									</div>
									<div class="card-footer">
										<div class="stats">
											<a href="javascript:void(0)" class="pointer" (click)="toggleOiDetail('invoiced'); $event.preventDefault()"><i class="material-icons">visibility</i> View</a>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
						<div class="col-12" *ngIf="oiDetailMetric" @throughputDetailEnter>
							<div class="card card-stats tpl3pl-throughput-detail mb-3">
								<div
									class="card-header card-header-icon"
									[class.card-header-rose]="oiDetailMetric === 'orders'"
									[class.card-header-warning]="oiDetailMetric === 'exported'"
									[class.card-header-info]="oiDetailMetric === 'invoiced'"
								>
									<div
										class="card-icon pointer"
										role="button"
										tabindex="0"
										(click)="closeThroughputDetail()"
										(keydown.enter)="closeThroughputDetail()"
										(keydown.space)="$event.preventDefault(); closeThroughputDetail()"
										title="Back to throughput summary"
										aria-label="Back to throughput summary"
									>
										<i class="material-icons" aria-hidden="true">{{
											oiDetailMetric === 'orders' ? 'assignment' : oiDetailMetric === 'exported' ? 'publish' : 'receipt'
										}}</i>
									</div>
									<p class="card-category mb-1">
										<a
											href="javascript:void(0)"
											class="pointer tpl3pl-throughput-detail__back d-inline-flex align-items-center text-white"
											(click)="closeThroughputDetail(); $event.preventDefault()"
										>
											<i class="material-icons">arrow_back</i> Back
										</a>
									</p>
									<h3 class="card-title mb-1">{{ throughputDetailTitle }}</h3>
									<p class="card-category mb-0 tpl3pl-throughput-detail__range">{{ oim.series_date_from }} → {{ oim.series_date_to }} · {{ oim.series_days }} day(s)</p>
								</div>
								<div class="card-body tpl3pl-oi-series-wrap">
									<p class="text-muted small mb-2">Date range applies to all three series.</p>
									<div class="tpl3pl-oi-filter-controls tpl3pl-oi-filter-controls--compact mb-3">
										<input type="date" class="form-control form-control-sm tpl3pl-oi-date" [(ngModel)]="oiSeriesFrom" name="tpl3plOiFromDetail" />
										<span class="text-muted small">to</span>
										<input type="date" class="form-control form-control-sm tpl3pl-oi-date" [(ngModel)]="oiSeriesTo" name="tpl3plOiToDetail" />
										<button type="button" class="btn btn-sm btn-primary" (click)="applyOiSeriesRange()">Apply</button>
										<button type="button" class="btn btn-sm btn-default" (click)="monthToDateAndReload()">MTD</button>
									</div>
									<app-tpl3pl-throughput-series
										[metric]="oiDetailMetric"
										[series]="oim.series"
										[reportTitle]="throughputDetailTitle"
										[dateRangeLabel]="(oim.series_date_from || '') + ' → ' + (oim.series_date_to || '') + ' · ' + (oim.series_days || 0) + ' day(s)'"
									></app-tpl3pl-throughput-series>
								</div>
								<div class="card-footer tpl3pl-throughput-detail__footer">
									<a routerLink="/tpl3pl/export-queue" class="btn btn-link btn-sm tpl3pl-throughput-detail__link">
										<i class="material-icons tpl3pl-throughput-detail__icon" aria-hidden="true">visibility</i>
										<span>Export queue</span>
									</a>
									<a routerLink="/tpl3pl/shipments" class="btn btn-link btn-sm tpl3pl-throughput-detail__link">
										<i class="material-icons tpl3pl-throughput-detail__icon" aria-hidden="true">visibility</i>
										<span>Shipments</span>
									</a>
								</div>
							</div>
						</div>
					</ng-container>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-primary card-header-icon">
								<div class="card-icon">
									<i class="material-icons">power</i>
								</div>
								<p class="card-category">Integration</p>
								<h3 class="card-title">{{ status?.integration_type || '—' }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right">
										Warehouse: {{ status?.warehouse_code || '—' }}<br>
										<span [class.text-success]="status?.enabled" [class.text-danger]="!status?.enabled">{{ status?.enabled ? 'Active' : 'Disabled' }}</span><span *ngIf="status?.test_mode"> · Test</span>
									</p>
								</small>
							</div>
							<div class="card-footer">
								<div class="stats">
									<a href="javascript:void(0)" (click)="loadStatus(); $event.preventDefault()" class="pointer"><i class="material-icons">refresh</i> Refresh</a>
								</div>
								<div class="stats">
									<a routerLink="/tpl3pl/config"><i class="material-icons">settings</i> 3PL settings</a>
								</div>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-success card-header-icon">
								<div class="card-icon">
									<i class="material-icons">inventory</i>
								</div>
								<p class="card-category">Catalog SKUs</p>
								<h3 class="card-title">{{ status?.catalog_items ?? 0 }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right">Active in-scope SKUs </p>
								</small>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-warning card-header-icon">
								<div class="card-icon">
									<i class="material-icons">local_shipping</i>
								</div>
								<p class="card-category">Order Export Queue</p>
								<h3 class="card-title">{{ (status?.queue_exported ?? 0) + (status?.queue_pending ?? 0) }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right">
										Exported: <span class="text-success">{{ status?.queue_exported ?? 0 }}</span> ·
										Pending: <span class="text-warning">{{ status?.queue_pending ?? 0 }}</span> ·
										Failed: <span class="text-danger">{{ status?.queue_failed ?? 0 }}</span>
										<span *ngIf="(status?.queue_dead_letter ?? 0) > 0"> · Dead: {{ status?.queue_dead_letter }}</span>
									</p>
								</small>
							</div>
							<div class="card-footer">
								<div class="stats">
									<a routerLink="/tpl3pl/export-queue"><i class="material-icons">visibility</i> View Queue</a>
								</div>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-info card-header-icon">
								<div class="card-icon">
									<i class="material-icons">store</i>
								</div>
								<p class="card-category">Inventory Synced</p>
								<h3 class="card-title">{{ status?.inventory_synced ?? 0 }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right">
										Pending: {{ status?.inventory_pending ?? 0 }} · Errors: <span [class.text-danger]="(status?.inventory_errors ?? 0) > 0">{{ status?.inventory_errors ?? 0 }}</span><br>
										Last sync: {{ (status?.last_sync | date:'short') || 'Never' }}
									</p>
								</small>
							</div>
							<div class="card-footer">
								<div class="stats">
									<a routerLink="/tpl3pl/inventory"><i class="material-icons">visibility</i> View</a>
								</div>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-info card-header-icon">
								<div class="card-icon">
									<i class="material-icons">local_shipping</i>
								</div>
								<p class="card-category">Shipments</p>
								<h3 class="card-title">{{ status?.shipments_total ?? 0 }}</h3>
								<small *ngIf="(status?.shipments_unprocessed ?? 0) > 0">
									<p class="card-category text-info text-justify mt-3 text-right">
										Unprocessed: <span class="text-warning">{{ status?.shipments_unprocessed }}</span>
									</p>
								</small>
							</div>
							<div class="card-footer">
								<div class="stats">
									<a routerLink="/tpl3pl/shipments"><i class="material-icons">visibility</i> View</a>
								</div>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-rose card-header-icon">
								<div class="card-icon">
									<i class="material-icons">show_chart</i>
								</div>
								<p class="card-category">Exports (24h)</p>
								<h3 class="card-title">{{ status?.exports_24h ?? 0 }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right">
										Failure rate: <span [class.text-danger]="(status?.failure_rate_24h ?? 0) > 10" [class.text-success]="(status?.failure_rate_24h ?? 0) === 0">{{ status?.failure_rate_24h ?? 0 }}%</span><br>
										Last export: {{ (status?.last_export | date:'short') || 'Never' }}
									</p>
								</small>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-danger card-header-icon">
								<div class="card-icon">
									<i class="material-icons">warning</i>
								</div>
								<p class="card-category">Recent errors</p>
								<h3 class="card-title">{{ status?.recent_errors?.length ?? 0 }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right tpl3pl-error-preview" *ngIf="status?.recent_errors?.length">
										{{ previewFirstError(status.recent_errors[0]) }}
									</p>
									<p class="card-category text-success text-justify mt-3 text-right" *ngIf="!status?.recent_errors?.length">
										No recent errors
									</p>
								</small>
							</div>
							<div class="card-footer">
								<div class="stats">
									<a routerLink="/tpl3pl/logs"><i class="material-icons">visibility</i> View logs</a>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
</div>